import React, {useState} from "react";
import axios from "axios"
import tmb_voccabulaire from "./tmb_voccabulaire";
import constants from "../constants";
import slug from "../slug";

const useRightDesk = (props) => {
  const [response, setResponse] = React.useState({})
  const [companyData, setCompanyData] = React.useState({})
  const [cats, setCats] = useState(null)

  const getVocabulary = (key, categories) => {
    const keytoslug = key.replace("category_", "").replace("objet_", "").replace("reason_", "").replace("reason_need_", "").replace("sub_reason_", "").replace("sub_reason_need_", "").replace("subject_", "").replace("sub_", "")
    const keyslugcat = categories?.filter( c => c.key === key)
    return {fr: (keyslugcat?.[0]?.title || keytoslug), en: (keyslugcat?.[0]?.title || keytoslug)}
  }
  const toNormalForm = (str = "") => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  const getCat = (answer, categories) => {
    console.log('GET CAT !!!!!!!!')
    console.log(answer)
    console.log(categories)
    let ccc

    if (answer.category?.length > 0) {
      console.log(answer.category)
      ccc = categories?.filter(c => c.key === answer.category[0]);
      if (window.location.hostname.includes('localhost')) console.log(ccc)

      if (answer.objet?.length > 0) {
        console.log(answer.objet)
        ccc = categories?.filter(c => c.key === answer.objet[0]);
        if (window.location.hostname.includes('localhost')) console.log(ccc)
      }

      if (answer.reason?.length > 0) {
        console.log(answer.reason)
        ccc = categories?.filter(c => c.key === answer.reason[0]);
        if (window.location.hostname.includes('localhost')) console.log(ccc)
      }

      if (answer.sub_reason?.length > 0) {
        console.log(answer.sub_reason)
        ccc = categories?.filter(c => c.key === answer.sub_reason[0]);
        if (window.location.hostname.includes('localhost')) console.log(ccc)
      }

      if (answer.reason_need?.length > 0) {
        console.log(answer.reason_need)
        ccc = categories?.filter(c => c.key === answer.reason_need[0]);
        if (window.location.hostname.includes('localhost')) console.log(ccc)
      }

      if (answer.sub_reason_need?.length > 0) {
        console.log(answer.sub_reason_need)
        ccc = categories?.filter(c => c.key === answer.sub_reason_need[0]);
        if (window.location.hostname.includes('localhost')) console.log(ccc)
      }
    }

    if (window.location.hostname.includes('localhost')) console.log(ccc?.[0])

    if (ccc?.length === 0) {
      console.log(ccc?.[0])
      ccc = categories?.filter(c => c.key === toNormalForm(tmb_voccabulaire["category_others"]?.['fr'].trim().toLowerCase()));
    }

    console.log(ccc?.[0])
    return ccc?.[0]
  }

  const assignedAgentByBranch = (agence, company) => {

    const pool = [
      {
        "status": 2,
        "city": "",
        "user_id": "916bbb30-86f9-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Eric",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243818309823",
        "is_admin": false,
        "lastname": "Mpoyi",
        "address": "",
        "is_owner": false,
        "email": "e.mpoyi@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "c1c22d60-8662-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "jovis",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243812243587",
        "is_admin": false,
        "lastname": "tscheinda",
        "address": "",
        "is_owner": false,
        "email": "j.tscheinda@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "3c29c200-8714-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Marlène",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021733",
        "is_admin": false,
        "lastname": "Masengo",
        "address": "",
        "is_owner": false,
        "email": "m.masengo@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "41ddfdd0-865e-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Gerard",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243812000001",
        "is_admin": false,
        "lastname": "Phambu",
        "address": "",
        "is_owner": false,
        "email": "g.phambu@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "5dab4770-86ea-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Esther",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243818310061",
        "is_admin": false,
        "lastname": "Mbala",
        "address": "",
        "is_owner": false,
        "email": "e.mbala@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "240e5e90-8711-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "jhyslain",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243817011438",
        "is_admin": false,
        "lastname": "Olenge",
        "address": "",
        "is_owner": false,
        "email": "j.olenge@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "6a652290-8660-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Bernice",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021732",
        "is_admin": false,
        "lastname": "Kabuya",
        "address": "",
        "is_owner": false,
        "email": "bernice.kabuya@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "4f1ea230-86f2-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Jimmy",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243827020786",
        "is_admin": false,
        "lastname": "Diangindu",
        "address": "",
        "is_owner": false,
        "email": "j.diangindu@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "6bc56820-865b-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Chris",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243818309666",
        "is_admin": false,
        "lastname": "Musoko",
        "address": "",
        "is_owner": false,
        "email": "c.musoko@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "6afa9010-86f5-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Junior",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021733",
        "is_admin": false,
        "lastname": "Okamba",
        "address": "",
        "is_owner": false,
        "email": "j.okamba@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "cc80e870-865f-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Estelle",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021732",
        "is_admin": false,
        "lastname": "Kabasele",
        "address": "",
        "is_owner": false,
        "email": "e.kabasele@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "4526f5c0-86f7-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Doris",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021733",
        "is_admin": false,
        "lastname": "Muhunga",
        "address": "",
        "is_owner": false,
        "email": "d.muhunga@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "34b4dd00-8662-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Christian",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021732",
        "is_admin": false,
        "lastname": "Kabasele",
        "address": "",
        "is_owner": false,
        "email": "c.kabasele@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "9ca7aed0-86f1-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Isaac",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243812242783",
        "is_admin": false,
        "lastname": "Kafilongo",
        "address": "",
        "is_owner": false,
        "email": "i.kafilongo@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "804492c0-86f2-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Benoit",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243827546537",
        "is_admin": false,
        "lastname": "Mokonzi",
        "address": "",
        "is_owner": false,
        "email": "b.mokonzi@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "02353c80-86e9-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Clémence",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243818310061 ",
        "is_admin": false,
        "lastname": "Bulungu",
        "address": "",
        "is_owner": false,
        "email": "c.bulungu@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "8d88f770-8664-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Jesus",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243812243587",
        "is_admin": false,
        "lastname": "Kazadi",
        "address": "",
        "is_owner": false,
        "email": "j.kazadi@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "d8527310-865c-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "IGOR",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243818309666",
        "is_admin": false,
        "lastname": "Bala",
        "address": "",
        "is_owner": false,
        "email": "i.bala@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "d1605ee0-86f8-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Gauthier ",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243818310060",
        "is_admin": false,
        "lastname": "Kayembe",
        "address": "",
        "is_owner": false,
        "email": "g.kayembe@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "168cf160-8661-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Purvince",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021732",
        "is_admin": false,
        "lastname": "Bompeti",
        "address": "",
        "is_owner": false,
        "email": "p.bompeti@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "8f343dd0-8661-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Obed",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021732",
        "is_admin": false,
        "lastname": "Lisika",
        "address": "",
        "is_owner": false,
        "email": "o.lisika@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "60a57e30-86f6-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Allegre",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021733",
        "is_admin": false,
        "lastname": "Makanzu",
        "address": "",
        "is_owner": false,
        "email": "a.makanzu@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "cac969e0-865e-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Gladis",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243812000001",
        "is_admin": false,
        "lastname": "Otshupele",
        "address": "",
        "is_owner": false,
        "email": "g.otshupele@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "fe1e0cf0-86f0-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Leatitia",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243818310061",
        "is_admin": false,
        "lastname": "Lumembo",
        "address": "",
        "is_owner": false,
        "email": "l.lumembo@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "77bbc320-86f8-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Evodie",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021733",
        "is_admin": false,
        "lastname": "Balengwa",
        "address": "",
        "is_owner": false,
        "email": "e.balengwa@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "dfc3b4c0-86f1-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Espérance",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243817011438",
        "is_admin": false,
        "lastname": "Malundama",
        "address": "",
        "is_owner": false,
        "email": "e.malundama@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "b6867150-86ed-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Orpa",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243818310061",
        "is_admin": false,
        "lastname": "Shinga",
        "address": "",
        "is_owner": false,
        "email": "o.shinga@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "ced18130-86f9-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Aboudramane",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243818309823",
        "is_admin": false,
        "lastname": "Keita",
        "address": "",
        "is_owner": false,
        "email": "a.keita@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "10d8b890-86f6-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Ines",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021733",
        "is_admin": false,
        "lastname": "Sanza",
        "address": "",
        "is_owner": false,
        "email": "i.sanza@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "fb07aad0-8664-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Fils georges",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243812243587",
        "is_admin": false,
        "lastname": "Lukanga",
        "address": "",
        "is_owner": false,
        "email": "f.lukanga@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "6c42da70-86e8-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Audry",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243818310061 ",
        "is_admin": false,
        "lastname": "Tshimanga",
        "address": "",
        "is_owner": false,
        "email": "a.tshimanga@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "8a3491c0-8663-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Jonathan",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243812243587",
        "is_admin": false,
        "lastname": "Mambulu",
        "address": "",
        "is_owner": false,
        "email": "j.mambulu@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "2a090320-8664-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Brunelle",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243812243587",
        "is_admin": false,
        "lastname": "Leta",
        "address": "",
        "is_owner": false,
        "email": "b.leta@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "af733fd0-86f5-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Gratien",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021733",
        "is_admin": false,
        "lastname": "Bahati",
        "address": "",
        "is_owner": false,
        "email": "g.bahati@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "41fe3a90-865f-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Steve",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243811021732",
        "is_admin": false,
        "lastname": "Kisweso",
        "address": "",
        "is_owner": false,
        "email": "s.kisweso@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "cc81a890-865b-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Betty",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243818309666",
        "is_admin": false,
        "lastname": "Deneef",
        "address": "",
        "is_owner": false,
        "email": "b.deneef@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "19501120-86f2-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "Casny",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243832389708",
        "is_admin": false,
        "lastname": "Mpadi",
        "address": "",
        "is_owner": false,
        "email": "c.mpadi@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      },
      {
        "status": 2,
        "city": "",
        "user_id": "7c479040-865d-11ef-815d-c3eb4ab96e3a",
        "sexe": "M",
        "firstname": "William",
        "language": "fr",
        "country": "CD",
        "image": "",
        "timezone": "GMT+01:00",
        "phone": "243812000001",
        "is_admin": false,
        "lastname": "Mbuyi",
        "address": "",
        "is_owner": false,
        "email": "wh.mbuyi@tmb.cd",
        "full_rights": [
          {
            "code": "USR",
            "group": "Simple User",
            "name": "RightDesk Simple User"
          }
        ],
        "rights_codes": [
          "USR"
        ],
      }
    ]

    if (company?.subdomain === "tmb") {
      return pool[Math.floor(Math.random() * pool.length)]
    } else {
      return {
        "firstname": "Orpa",
        "lastname": "shinga",
        "phone": "243818310061",
        "sexe": "M",
        "language": "fr",
        "lang_dir": "ltr",
        "fullname": "Orpa shinga",
        "email": "o.shinga@tmb.cd",
        "userid": "6a2e4c70-0f67-11ec-88ea-fbb3eb33f232",
        "publickey": "POKB19302SOK97W",
        "alias": "MB1O5HSOK97W",
        "firstlogin": 1,
        "subdomain": window.location.hostname.split(".")[0],
        "company": "Trust Merchant Bank",
        "is_admin": true,
        "session_id": "hidyFfAAkWDLARLBmjSkw0kEtdP6Ax1aFty6AoWFtssYK",
        "full_rights": [
          {
            "code": "USA",
            "group": "Simple User",
            "name": "RightCare Simple User"
          },
          {
            "code": "MAN",
            "group": "Administration",
            "name": "RightCare Manager"
          }
        ],
        "rights_codes": [
          "USA",
          "MAN"
        ],
        "apisid": "1wEZXyESJfMXZbi6AFMABWeeq7P8tRswo9PjlRF2",
        "checked": true
      }
    }
  }
  const send = (answers, publickey, company, categories) => {
    setCats(categories)
    setCompanyData({...companyData, ...company})
    // setTimeout(() => {
    //     setResponse({xnumber: 23423432, error: "Une erreure est survenue. Veuiller ressayer."})
    // }, 5000)
    const agence = answers.clientAgence || answers.formMagnetiqueForm?.agency || answers.formWalletForm?.agency

    let cat = getCat(answers, categories)
    console.log('sending cat userightdesk !!!!!!!!!')
    let data = {
      "language": "fr",
      "publickey": window.location.hostname.split(".")[0] === "tmb" ? "trust-merchant-bank" : window.location.hostname.split(".")[0] || companyData?.publickey || company?.publickey || publickey,
      "company_information": {
        "name": companyData?.name || company?.name,
        "logo": companyData?.logo || company?.logo,
        "countryname": companyData?.country?.countryname || company?.country?.countryname,
        "address": companyData?.companyAdress || company?.companyAdress
      },
      "ticket_information": {
        "message": answers.comment || answers.comment || "",

        "subject": cat?.title,
        "subject_id": cat?.id,
        "cat_parents_ids": cat?.all_parent_id,
        "sla": cat?.sla,
        "priority": cat?.priority,

        "category": {
          "label": "Technical"
        },
        "custom_ticket_fields": [],
        "status": {
          "name": "New",
          "label": "Ticket without agent assign"
        },
        "assigned_agent": assignedAgentByBranch(agence, company),
        "created_by": {
          "agent_id": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "first_name": "Right",
          "last_name": "Bot",
          "email": "rightcare@right-com.com",
          "telephone": "+22966021852"
        },
        "closed": false,
      }
    };
    if (answers["category"]) {
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Categorie ",
        "label_fr": "Categorie ",
        "type": "Options",
        "mandatory": true,
        "value": getVocabulary(answers.category[0], categories)?.["fr"]
      })
    }
    if (answers["objet"]) {
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Sujet ",
        "label_fr": "Sujet ",
        "type": "Options",
        "mandatory": true,
        "value": getVocabulary(answers.objet[0], categories)?.["fr"]
      })
    }
    if (answers["reason"]) {
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Objet ",
        "label_fr": "Objet ",
        "type": "Options",
        "mandatory": true,
        "value": getVocabulary(answers.reason[0], categories)?.["fr"]
      })
    }
    if (answers["sub_reason"]) {
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Raison ",
        "label_fr": "Raison ",
        "type": "Options",
        "mandatory": true,
        "value": getVocabulary(answers.sub_reason[0], categories)?.["fr"]
      })
    }
    if (answers["reason_need"]) {
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Motif ",
        "label_fr": "Motif ",
        "type": "Options",
        "mandatory": true,
        "value": getVocabulary(answers.reason_need[0], categories)?.["fr"]
      })
    }
    if (answers["sub_reason_need"]) {
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Cause ",
        "label_fr": "Cause ",
        "type": "Options",
        "mandatory": true,
        "value": getVocabulary(answers.sub_reason_need[0], categories)?.["fr"]
      })
    }
    

    if (answers.formWalletForm) {
      // console.log('wallet form customer infos')

      if (answers.formWalletForm.files) {
        data["ticket_information"]["files"] = answers.formWalletForm.files
      }
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Branche",
        "label_fr": "Agence",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formWalletForm.agency
      })
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Account Number",
        "label_fr": "Numero de compte",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formWalletForm.accountNumber
      })
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Tmb Money Number",
        "label_fr": "Numero Tmb Money",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formWalletForm.tmbMoneyNumber
      })
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Transaction Date",
        "label_fr": "Date Transaction",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formWalletForm.transactionDate
      })
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Transaction Amount",
        "label_fr": "Montant de la Transaction",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formWalletForm.transactionAmount
      })
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Transaction Reference",
        "label_fr": "Reference de la Transaction",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formWalletForm.transactionRef
      })

      data["ticket_information"]["customer_information"] = [
        {
          "type": "text",
          "name": "First name",
          "value": answers.formWalletForm.firstname
        },
        {
          "type": "text",
          "name": "Last name",
          "value": answers.formWalletForm.lastname
        },
        {
          "type": "email",
          "name": "Email Address",
          "value": answers.formWalletForm.email
        },
        {
          "type": "number",
          "name": "Telephone",
          "value": answers.formWalletForm.phone
        }
      ]

    }
    if (answers.formMagnetiqueForm) {
      // console.log('magnetic form customer infos')

      if (answers.formMagnetiqueForm.files) {
        data["ticket_information"]["files"] = answers.formMagnetiqueForm.files
      }
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Branche",
        "label_fr": "Agence",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formMagnetiqueForm.agency
      })
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Account Number",
        "label_fr": "Numero de compte",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formMagnetiqueForm.accountNumber
      })
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Type Of Card",
        "label_fr": "Type De Carte",
        "type": "Options",
        "mandatory": true,
        "value": answers.formMagnetiqueForm.typeCard
      })
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Card Number",
        "label_fr": "Numero Carte",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formMagnetiqueForm.cardNumber
      })
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Transaction Date",
        "label_fr": "Date Transaction",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formMagnetiqueForm.transactionDate
      })
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Transaction Time",
        "label_fr": "Heure Transaction",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formMagnetiqueForm.transactionTime
      })
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Transaction Amount",
        "label_fr": "Montant de la Transaction",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formMagnetiqueForm.transactionAmount
      })
      data["ticket_information"]["custom_ticket_fields"].push({
        "label_en": "Transaction Location",
        "label_fr": "Lieu de la Transaction",
        "type": "Open Text",
        "mandatory": true,
        "value": answers.formMagnetiqueForm.transactionLocation
      })

      data["ticket_information"]["customer_information"] = [
        {
          "type": "text",
          "name": "First name",
          "value": answers.formMagnetiqueForm.firstname
        },
        {
          "type": "text",
          "name": "Last name",
          "value": answers.formMagnetiqueForm.lastname
        },
        {
          "type": "email",
          "name": "Email Address",
          "value": answers.formMagnetiqueForm.email
        },
        {
          "type": "number",
          "name": "Telephone",
          "value": answers.formMagnetiqueForm.phone
        }
      ]

    }
    if (answers.standard) {
      // console.log('standard form customer infos')
      if (answers.files) {
        data["ticket_information"]["files"] = answers.files
      }
      if (answers.accountNumber) {
        data["ticket_information"]["custom_ticket_fields"].push({
          "label_en": "Numéro de compte",
          "label_fr": "Numéro de compte",
          "type": "Open Text",
          "mandatory": true,
          "value": answers.accountNumber
        })
      }
      if (answers.clientNumber) {
        data["ticket_information"]["custom_ticket_fields"].push({
          "label_en": "Numéro client",
          "label_fr": "Numéro client",
          "type": "Open Text",
          "mandatory": true,
          "value": answers.clientNumber
        })
      }
      if (answers.dateTraitement) {
        data["ticket_information"]["custom_ticket_fields"].push({
          "label_en": "Date de la demande",
          "label_fr": "Date de la demande",
          "type": "Open Text",
          "mandatory": true,
          "value": answers.dateTraitement
        })
      }
      if (answers.clientAgence) {
        data["ticket_information"]["custom_ticket_fields"].push({
          "label_en": "Agence",
          "label_fr": "Agence",
          "type": "Open Text",
          "mandatory": true,
          "value": answers.clientAgence
        })
      }
      if (answers.montant) {
        data["ticket_information"]["custom_ticket_fields"].push({
          "label_en": "Montant",
          "label_fr": "Montant",
          "type": "Open Text",
          "mandatory": true,
          "value": answers.montant
        })
      }
      if (answers.clientTypeContrat) {
        data["ticket_information"]["custom_ticket_fields"].push({
          "label_en": "Type de contrat",
          "label_fr": "Type de contrat",
          "type": "Open Text",
          "mandatory": true,
          "value": answers.clientTypeContrat
        })
      }
      if (answers.numeroCheque) {
        data["ticket_information"]["custom_ticket_fields"].push({
          "label_en": "Numéro de chèque",
          "label_fr": "Numéro de chèque",
          "type": "Open Text",
          "mandatory": true,
          "value": answers.numeroCheque
        })
      }
      if (answers.details_de_la_reclamation) {
        data["ticket_information"]["custom_ticket_fields"].push({
          "label_en": "(Date de l’opération, informations complémentaires…)",
          "label_fr": "(Date de l’opération, informations complémentaires…)",
          "type": "Open Text",
          "mandatory": true,
          "value": answers.details_de_la_reclamation
        })
      }

      if (answers.dateRemise) {
        data["ticket_information"]["custom_ticket_fields"].push({
          "label_en": "La date de remise",
          "label_fr": "La date de remise",
          "type": "Open Text",
          "mandatory": true,
          "value": answers.dateRemise
        })
      }
      if (answers.clientCommentaire) {
        data["ticket_information"]["custom_ticket_fields"].push({
          "label_en": "Commentaire",
          "label_fr": "Commentaire",
          "type": "Open Text",
          "mandatory": true,
          "value": answers.clientCommentaire
        })
      }


      data["ticket_information"]["customer_information"] = [
        {
          "type": "text",
          "name": "First name",
          "value": answers.firstname
        },
        {
          "type": "text",
          "name": "Last name",
          "value": answers.lastname
        },
        {
          "type": "email",
          "name": "Email Address",
          "value": answers.email
        },
        {
          "type": "number",
          "name": "Telephone",
          "value": answers.phone
        }
      ]

    }

    const getBaseUrlFromCurrentUrl = () => {
      const currentUrl = window.location.href;
      try {
        const parsedUrl = new URL(currentUrl);
        return parsedUrl.hostname;
      } catch (error) {
        console.error('Erreur lors de l\'extraction de l\'URL', error);
        return null;
      }
    }

    const MY_URL = getBaseUrlFromCurrentUrl();
    let rightDeskUrl = MY_URL == "tmb.webform.tmb.cd" ? constants.intern.rightDeskUrl : constants.extern.rightDeskUrl
    //let rightDeskUrl = ""

    if (window.location.hostname.includes('localhost')) {
      rightDeskUrl = constants.prod.rightDeskUrl
    }

    const config = {
      method: 'post',
      url: rightDeskUrl + '/api/v1/webform/ticket',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(data)
    };

    if (window.location.hostname.split(".")[2] === 'localhost') {
      console.log(data)
    } else {
      axios(config)
        .then(function (response) {
          // console.log(response)
          setResponse(response.data.data);
        })
        .catch(function (error) {
          // console.log(error)
        });
    }

  }
  const setCompany = (company) => {
    // console.log(company)
    setCompanyData(company)
  }
  return {send, response, setResponse, setCompany}
}

export default useRightDesk
